import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import classNames from "classnames";

import { themeOptionsStyls } from "../themeEditor_style";
import { getStaticUrl } from "js/config";

const ThemeOption = ({
    classes,
    item,
    property,
    disabled,
    update,
    selected
}) => {
    return (
        <div>
            <IconButton
                classes={{
                    root: classes.item
                }}
                disabled={disabled || false}
                className={classNames({ selected: selected })}
                onClick={() => update({ [property]: item.value })}
            >
                <img src={getStaticUrl(item.src)} />
            </IconButton>
            <label>{item.label}</label>
        </div>
    );
};
export default withStyles(themeOptionsStyls)(ThemeOption);
